import styled from '@emotion/styled';
import { ClassAttributes, createElement, Suspense } from 'react';
import { Redirect, Route, Switch } from 'react-router';

import ConfigurationPage from '../connected/ConfigurationPage';
import CreationSetDetailPage from '../connected/CreationSetDetailPage';
import { MyAssignmentsPage } from '../connected/MyAssignmentsPage';
import { NewCreationPage } from '../connected/NewCreationPage';
import OfferDetailPage from '../connected/OfferDetailPage';
import OffersListPage from '../connected/OffersListPage';
import ProjectDiffPage from '../connected/ProjectDiffPage';
import ShowCreationPage from '../connected/ShowCreationPage';

type Props = ClassAttributes<HTMLElement> & {
  className?: string;
};

const SignedInScreen = ({ className }: Props) => (
  <Root className={className}>
    <Suspense fallback={<div />}>
      <Switch>
        <Route
          exact
          sensitive
          path={['/creation_sets/o/:offerId/a/:assignmentId', '/creation_sets/o/:offerId']}
          component={CreationSetDetailPage}
        />
        <Route
          exact
          sensitive
          path="/creation_sets/:creationSetId/creations/a/:assignmentId/cf/:creativeFormatId/new"
          component={NewCreationPage}
        />
        <Route exact sensitive path="/creations/:creationId" component={ShowCreationPage} />
        <Route exact sensitive path="/projects/:projectId/diff/" component={ProjectDiffPage} />
        <Route exact sensitive path="/offers" component={OffersListPage} />
        <Route exact sensitive path="/offers/:offerId" component={OfferDetailPage} />
        <Route exact sensitive path="/my_assignments" component={MyAssignmentsPage} />
        <Route exact sensitive path="/settings" component={ConfigurationPage} />
        <Redirect from="/" to="/my_assignments" />
      </Switch>
    </Suspense>
  </Root>
);

const Root = styled('div')({});

export default SignedInScreen;
